import React, { forwardRef } from "react";
import ReCAPTCHA from "react-google-recaptcha";

const Captcha = forwardRef(({ onVerify, onExpired }, ref) => {
    const siteKey = process.env.REACT_APP_GoogleRecaptchaSiteKey;

    if (!siteKey) return null;

    return (
        <ReCAPTCHA
            ref={ref}
            sitekey={siteKey}
            onChange={onVerify}
            onExpired={() => onVerify(null)}
        />
    );
});

export default Captcha;
